var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-warning m-0"},[_vm._v(" Üçüncü taraf ülkesi ile organizasyon ülkesi eşit değil ise ")])
}
var staticRenderFns = []

export { render, staticRenderFns }